
let bx = window.BX;

function DialogService ($q){
    return {
     
        info: function(msg){
            bx.UI.Dialogs.MessageBox.alert(
                msg
            )
        },
        confirm: function(title, msg){
          
            var deffered= $q.defer();
            

            bx.UI.Dialogs.MessageBox.show(
                {
                   message:  msg?msg:'Вы уверены?', 
                   title:    title?title:'Вопрос', 
                   buttons: [
                      new bx.UI.Button(
                      {
                        
                       
                         color: bx.UI.Button.Color.PRIMARY,
                         text: "Да",
                         onclick: function(button) {
                             button.context.close();
                             deffered.resolve({});
                         }
                      }
                      ),
                      new bx.UI.Button(
                        {
                           color: bx.UI.Button.Color.LINK,
                           text: "Нет",
                           onclick: function(button) {
                               button.context.close();
                               deffered.reject({});
                           }
                        }
                        )
                   ],
                }
            );

  
          return deffered.promise; 
        },
  
        select: function(title, data){
            var deffered= $q.defer();
            


            var   msg = '<div class="ui-ctl ui-ctl-after-icon ui-ctl-dropdown"> \
                <div class="ui-ctl-after ui-ctl-icon-angle"></div>\
                <select class="ui-ctl-element">';
                
                        data.forEach(element => {
                            msg+='<option value="'+element.value+'">'+element.name+'</option>';
                        });
                
                    
                    msg+='    </select>\
            </div>';

            bx.UI.Dialogs.MessageBox.show(
                {
                   message:  msg, 
                   title:    title?title:'Вопрос', 
                   buttons: [
                      new bx.UI.Button(
                      {
                        
                       
                         color: bx.UI.Button.Color.PRIMARY,
                         text: "Выбрать",
                         onclick: function(button) {
                            let selectNode =bx.findChild(this.context.contentContainer, {
                                    "tag" : "select",
                                
                                }, 
                                true
                            );
                               
                             button.context.close();
                             deffered.resolve({id: selectNode.value});
                         }
                      }
                      ),
                      new bx.UI.Button(
                        {
                           color: bx.UI.Button.Color.LINK,
                           text: "Отмена",
                           onclick: function(button) {
                               button.context.close();
                               deffered.reject({});
                           }
                        }
                        )
                   ],
                }
            );

            return deffered.promise; 

        }
        
      };
}

DialogService.$inject = ['$q']; 

export {DialogService}



// WEBPACK FOOTER //
// ./src/app.dialog.services.js